import React from 'react';
import { motion } from 'framer-motion';

const variants = {
    initial: { opacity: 0, y: 18, filter: 'blur(5px)' },
    in: { opacity: 1, y: 0, filter: 'blur(0px)' },
    out: { opacity: 0, y: -18, filter: 'blur(5px)' },
};

const transition = { type: 'tween', ease: [0.43, 0.13, 0.23, 0.96], duration: 0.38 };

const PageTransition = ({ children }) => (
    <motion.div initial="initial" animate="in" exit="out" variants={variants} transition={transition} style={{ width: '100%' }}>
        {children}
    </motion.div>
);

export default PageTransition;
